import { configureStore } from '@reduxjs/toolkit';
import user from './user/reducer';
import appTrack from './appTrack/reducer';
import staticPages from './staticPages/reducer';
import forms from './forms/reducer';
import adminPanel from './adminPanel/reducer'
import activeForm from './activeForm/reducer';
import { getExpiry, loadState, saveState } from 'utils/localStorage';
import { clearMapDetails } from './staticPages/actions';

const persistedState = loadState();

export const store = configureStore({
  reducer: {
    activeForm,
    user,
    forms,
    appTrack,
    staticPages,
    adminPanel,
  },
  preloadedState: persistedState,
});

//maybe for later use
export const setClearStateTimeout = () => {
  const expiry = getExpiry();
  if (expiry) {
    setTimeout(() => {
      store.dispatch(clearMapDetails());
    }, expiry);
  } else {
    store.dispatch(clearMapDetails());
  }
};

store.subscribe(() => {
  saveState(store.getState());
});
